/* @flow */
import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import Breadcrumbs from '../BreadCrumbs/Breadcrumbs';
import routerActions from '../../actions/router';
import {trigger as edapTrigger, GENERIC_EVENT} from '../../utils/edapWrapper';
import Headliner from './Headliner';

import './HeadlineWithBreadcrumbs.less';

type DispatchProps = {
    onClickBreadcrumb: typeof routerActions.breadcrumb
};

type Props = {
    headline?: string,
    breadcrumbs?: Array<{url: string, name: string}>
} & DispatchProps;

const noop = Function.prototype;

export function HeadlineWithBreadcrumbs({
    headline,
    breadcrumbs,
    onClickBreadcrumb
}: Props) {
    let handleCrumbNameClick;
    if (breadcrumbs) {
        handleCrumbNameClick = (event: SyntheticEvent<*>) => {
            const url = event.currentTarget.parentElement.getAttribute('href');
            const crumbPos =
                event.currentTarget &&
                event.currentTarget.nextSibling.getAttribute('content');
            const crumbsLen = breadcrumbs.length;

            edapTrigger(GENERIC_EVENT, {
                eventaction: 'breadcrumb click',
                eventlabel: `${crumbPos}:${crumbsLen}`
            });

            onClickBreadcrumb({url, event});
        };
    } else {
        handleCrumbNameClick = noop;
    }

    return (
        <div
            className="HeadlineWithBreadcrumbs"
            data-wdio="HeadlineWithBreadcrumbs"
        >
            {headline && <Headliner headline={headline} />}
            {breadcrumbs && (
                <div className="HeadlineWithBreadcrumbs__breadcrumbs">
                    <Breadcrumbs
                        isLastCrumbLinked
                        crumbs={breadcrumbs}
                        onClickCrumbName={handleCrumbNameClick}
                    />
                </div>
            )}
        </div>
    );
}

const mapDispatchToProps = {
    onClickBreadcrumb: routerActions.breadcrumb
};

export default compose(
    connect(
        null,
        mapDispatchToProps
    )
)(HeadlineWithBreadcrumbs);
